var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{class:("alert alert-" + _vm.type + " alert-dismissible fade show")},[_c('strong',[_vm._v(_vm._s(_vm._f("ucFirst")(_vm.type))+"!")]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }